<template>
  <v-form
    v-if="loaded"
    ref="form">
    <tab-title
      :car-id="appointment.car.id"
      text="注意事項" />
    <cp-radio
      :value="carFields.EXTERIOR_SMALL_WOUNDS"
      :items="yesOrNo"
      :rules="[$rules.isRequired]"
      label="小傷 / うす傷(外装全体) *"
      hint="爪が引っかかる 1cm 未満の小傷や、爪は引っかからないが目立つ薄い傷が多い場合に「あり」を選択。"
      data-label-scroll="EXTERIOR_SMALL_WOUNDS"
      @change="(value) => updateNotes('EXTERIOR_SMALL_WOUNDS', value)"
    />
    <cp-radio
      :value="carFields.EXTERIOR_FADED"
      :items="yesOrNo"
      :rules="[$rules.isRequired]"
      label="色あせ(外装全体) *"
      data-label-scroll="EXTERIOR_FADED"
      @change="(value) => updateNotes('EXTERIOR_FADED', value)"
    />
    <cp-radio
      :value="carFields.PET_HAIR"
      :items="smallOrBig"
      :rules="[$rules.isRequired]"
      label="ペット毛 *"
      data-label-scroll="PET_HAIR"
      @change="(value) => updateNotes('PET_HAIR', value)"
    />
    <v-select
      :value="carFields.ODOR"
      :items="odorOptions"
      :rules="[$rules.isRequired]"
      label="匂い *"
      data-label-scroll="ODOR"
      @change="(value) => updateNotes('ODOR', value)"
    />
    <v-text-field
      v-if="carFields.ODOR === 'OTHER'"
      :value="carFields.ODOR_OTHER"
      :rules="[$rules.isRequired]"
      label="具体的に *"
      data-label-scroll="ODOR_OTHER"
      @blur="({ target }) => updateNotes('ODOR_OTHER', target.value)"
    />
    <cp-radio
      :value="carFields.INTERIOR_SCRATCH"
      :items="yesOrNo"
      :rules="[$rules.isRequired]"
      label="小傷 / スレ(内装全体) *"
      data-label-scroll="INTERIOR_SCRATCH"
      @change="(value) => updateNotes('INTERIOR_SCRATCH', value)"
    />
    <cp-radio
      :value="carFields.INTERIOR_DIRT"
      :items="yesOrNo"
      :rules="[$rules.isRequired]"
      label="汚れ *"
      data-label-scroll="INTERIOR_DIRT"
      @change="(value) => updateNotes('INTERIOR_DIRT', value)"
    />
    <cp-radio
      :value="carFields.INTERIOR_YELLOWED"
      :items="yesOrNo"
      :rules="[$rules.isRequired]"
      label="黄ばみ(内装全体) *"
      data-label-scroll="INTERIOR_YELLOWED"
      @change="(value) => updateNotes('INTERIOR_YELLOWED', value)"
    />
    <v-select
      :value="carFields.EXTERNAL_SUSPENSION"
      :items="externalSuspensionOptions"
      :rules="[$rules.isRequired]"
      label="社外足回り装備 *"
      data-label-scroll="EXTERNAL_SUSPENSION"
      @change="(value) => updateNotes('EXTERNAL_SUSPENSION', value)"
    />
    <cp-radio
      :value="carFields.ENGINE_ABNORMAL_SOUND"
      :items="yesOrNo"
      :rules="[$rules.isRequired]"
      label="エンジン異音 *"
      data-label-scroll="ENGINE_ABNORMAL_SOUND"
      @change="(value) => updateNotes('ENGINE_ABNORMAL_SOUND', value)"
    />
    <cp-radio
      :value="carFields.ENGINE_RUST_AND_CORROSION"
      :items="smallOrBig"
      :rules="[$rules.isRequired]"
      label="エンジンルームサビ・腐食 *"
      data-label-scroll="ENGINE_RUST_AND_CORROSION"
      @change="(value) => updateNotes('ENGINE_RUST_AND_CORROSION', value)"
    />
    <cp-radio
      :value="carFields.BELOW_RUST_AND_CORROSION"
      :items="smallOrBig"
      :rules="[$rules.isRequired]"
      label="下回りサビ・腐食 *"
      data-label-scroll="BELOW_RUST_AND_CORROSION"
      @change="(value) => updateNotes('BELOW_RUST_AND_CORROSION', value)"
    />
    <cp-radio
      :value="carFields.SUSPENSION_SYSTEM_RUST_CORROSION"
      :items="smallOrBig"
      :rules="[$rules.isRequired]"
      label="足まわりサビ・腐食 *"
      data-label-scroll="SUSPENSION_SYSTEM_RUST_CORROSION"
      @change="(value) => updateNotes('SUSPENSION_SYSTEM_RUST_CORROSION', value)"
    />
    <cp-radio
      :value="carFields.OIL_LEAK"
      :items="oilLeakOptions"
      :rules="[$rules.isRequired]"
      label="オイル系漏れ *"
      data-label-scroll="OIL_LEAK"
      @change="(value) => updateNotes('OIL_LEAK', value)"
    />
    <cp-radio
      :value="carFields.WARNING_LIGHT"
      :items="yesOrNo"
      :rules="[$rules.isRequired]"
      label="警告灯 *"
      data-label-scroll="WARNING_LIGHT"
      @change="(value) => updateNotes('WARNING_LIGHT', value)"
    />
    <cp-radio
      :value="carFields.HAIL_DAMAGED_CAR"
      :items="hailDamageOptions"
      :rules="[$rules.isRequired]"
      label="雹害車 *"
      data-label-scroll="HAIL_DAMAGED_CAR"
      @change="(value) => updateNotes('HAIL_DAMAGED_CAR', value)"
    />
    <v-textarea
      v-model="appointment.car.officeComment"
      label="その他特記事項"
      rows="3"
      @input="updateCar({ field: 'officeComment', value: appointment.car.officeComment })"
    />
    <v-divider class="my-5" />
    <v-btn
      outline
      color="info"
      block
      large
      to="repairs#top">次へ</v-btn>
  </v-form>
</template>

<script>
import {
  getCarWith,
  GET_CAR_FIELDS,
} from '../../queries';

import {
    yesOrNo,
    smallOrBig,
    odorOptions,
    oilLeakOptions,
    hailDamageOptions,
    externalSuspensionOptions,
  } from '../../options';

const defaultCarFields = [
  'EXTERIOR_SMALL_WOUNDS',
  'EXTERIOR_FADED',
  'PET_HAIR',
  'ODOR',
  'ODOR_OTHER',
  'INTERIOR_SCRATCH',
  'INTERIOR_DIRT',
  'INTERIOR_YELLOWED',
  'EXTERNAL_SUSPENSION',
  'ENGINE_ABNORMAL_SOUND',
  'ENGINE_RUST_AND_CORROSION',
  'BELOW_RUST_AND_CORROSION',
  'SUSPENSION_SYSTEM_RUST_CORROSION',
  'OIL_LEAK',
  'WARNING_LIGHT',
  'HAIL_DAMAGED_CAR',
].reduce((acc, cur) => ({
  ...acc,
  [cur]: null,
}), {});

export default {
  props: {
    appointmentId: {
      type: [String, Number],
      default: '',
    },
  },
  apollo: {
    carFields: {
      query: GET_CAR_FIELDS,
      fetchPolicy: 'network-only',
      skip() {
        return !this.appointment || !this.appointment.car.id;
      },
      variables() {
        return {
          carId: this.appointment.car.id,
        };
      },
      update({ carFields }) {
        this.loaded = true;
        return {
          ...defaultCarFields,
          ...carFields.data.reduce((acc, cur) => ({
            ...acc,
            [cur.code]: cur.value,
          }), {}),
        };
      },
    },
    appointment: {
      query: getCarWith(['officeComment']),
      fetchPolicy: 'network-only',
      variables() {
        return { id: parseInt(this.$route.params.id, 10) };
      },
      result() {
        this.$apollo.queries.carFields.refetch();
      },
    },
  },
  data() {
    return {
      tab: 'attention',
      yesOrNo,
      smallOrBig,
      odorOptions,
      oilLeakOptions,
      hailDamageOptions,
      externalSuspensionOptions,
      carFields: defaultCarFields,
      loaded: false,
    };
  },
  methods: {
    updateNotes(code, value) {
      if (!this.appointment || !this.appointment.car) return null;

      return this.updateField({
        code,
        value,
        carId: this.appointment.car.id,
        typeId: 81,
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/tabs/AttentionTab.vue